import { BaseUrl, NewUpdatedBaseUrl } from "../../BaseUrl/BaseUrl";
import { getApiWithAuthorization, getApiWithoutAuthorization, postApiWithAuthorization, postApiWithoutAuthorization } from "../ApiMethod/ApiMethod";

export const GetUserModel = async (id) => {
    const url = `${BaseUrl}/GetUserModel?USER_ID=${id}`;
    const res = await getApiWithoutAuthorization(url);
    return res;
};
export const UserRegNewWithMob = async (params, id) => {
    const url = `${BaseUrl}/UserRegNewWithMob?USER_ID=${id}`;
    const res = await postApiWithoutAuthorization(url, params);
    return res;
};
export const UpdateProfile = async (params) => {
    const url = `${NewUpdatedBaseUrl}/Login/UpdateProfile`;
    const res = await postApiWithAuthorization(url, params);
    return res;
};

export const GetProfileDetails = async (UserKeyID) => {
    const url = `${NewUpdatedBaseUrl}/Login/GetProfileDetails?UserKeyID=${UserKeyID}`;
    const res = await getApiWithAuthorization(url);
    return res;
};
